
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CollaboratorService } from "@/services/timetrack/CollaboratorService"
import Collaborator from "@/types/collaborator/Collaborator"

@Component({
  filters: {
  },
  components: {
  }
})
export default class CollaboratorEdit extends Vue {
  private valid = false
  private updateProcess = false
  private email: string | null = null
  private salary: number | null = null
  private error: string | null = null
  private collaboratorToBeChanged: Collaborator | null = null

  private collaborationService = new CollaboratorService()

  @Prop({ required: true })
  private projectId!: string

  private notEmptyRule = [
    (v: any) => !!v || this.$t('global.required')
  ]

  private emailRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /.+@.+/.test(v) || this.$t('account.mailNotValid')
  ]

  @Watch('error')
  private resetError () {
    if (this.error) {
      setTimeout(() => {
        this.error = null
      }, 3000)
    }
  }

  created () {
    this.initEventListeners()
  }

  private get validForm () {
    if (!this.updateProcess) {
      return !this.valid
    } else {
      return !this.valid ||
        this.salary === this.collaboratorToBeChanged?.collaboratorSalary
    }
  }

  private initEventListeners () {
    this.$root.$on('collaboratorGotSelected', (collaborator: Collaborator) => {
      this.updateProcess = true
      this.email = collaborator.collaboratorMail
      this.salary = collaborator.collaboratorSalary
      this.collaboratorToBeChanged = collaborator
    })
  }

  private btnClicked () {
    if (this.updateProcess) {
      this.updateUser()
    } else {
      this.inviteUser()
    }
  }

  private resetForm () {
    this.updateProcess = false
    if (this.$refs && this.$refs.form) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.$refs.form.reset()
    }
  }

  private inviteUser () {
    if (!this.salary || !this.email || !this.projectId) return
    this.collaborationService.addCollaboratorInvitation(this.projectId, this.email, this.salary)
      .then(() => {
        this.resetForm()
        this.$emit('added')
      }).catch((error) => {
        const errorMessage = this.$t(error.message)
        if (errorMessage) {
          this.error = errorMessage as string
        } else {
          this.$store.dispatch('error/setError', errorMessage)
        }
      })
  }

  private updateUser () {
    if (!this.salary || !this.email || !this.projectId || !this.collaboratorToBeChanged || !this.collaboratorToBeChanged.id) return
    this.collaborationService.setCollaboratorSalary(this.projectId, this.collaboratorToBeChanged.id, this.salary)
      .then(() => {
        this.resetForm()
        this.$emit('added')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }
}
